<div #dropdown [@SearchExpand]="(open$ | async) ? 'expanded' : 'not-expanded'" class="box tw-w-full">
    <div class="tw-relative">
        <button
            role="none"
            aria-hidden="true"
            tabindex="-1"
            [ariaDisabled]="!searchControl.value"
            appSearch
            [term]="searchControl.value"
            [attr.aria-label]="'v3-header-placeholder-search' | translate"
            buttonDataTest="headerSearchButton"
            type="button"
        >
            <app-icon name="search" />
        </button>
        <input
            (focus)="open()"
            appComboboxTypeahead
            (keydown.enter)="onEnter()"
            [dropdownEl]="dropdown"
            [typeahead]="true"
            [ariaControls]="id"
            class="searchbox"
            type="text"
            [placeholder]="'v3-header-placeholder-search' | translate"
            [formControl]="searchControl"
            #searchInput
            data-test="nav-search-input"
            [attr.aria-label]="'navbar.search.input.label' | translate"
        />
        @if (searchControl.value) {
            <button class="clear-search-btn" (click)="removeValue()" [attr.aria-label]="'clear-search' | translate" type="button">
                <app-icon name="x" />
            </button>
        }
        @if (open$ | async) {
            <div @Grow>
                <app-results [value]="searchControl.value" />
            </div>
        }
    </div>
</div>
